import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { get, ImageUrl } from '../../ApiServices/ApiServices';
import { useNavigate, useLocation } from 'react-router';
import moment from "moment";
import { useForm } from "react-hook-form";
import { Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Component/Loader';
import {
    fetchSingleOrderStart,
    fetchSingleOrderSuccess,
    fetchSingleOrderFailure
} from '../../redux/singleOrderSlice';
const OrderReview = ({
    onRewSubmit,
    onSubmit,
    RestShirtSubmit,
    ResetVest,
    ResetShoe,
    ResetJewelry,
    RecetTie,
    RecetPocket,
    RecetCoat,
    RecetPant,

    onBack,
    refid,
    showShirt,
    setShowShirt,
    showVest,
    setShowVest,
    showShoes,
    setShowShoes,
    setShowTie,
    showTie,

    setShowPocket,
    ShowPocket,
    setShowjewelry,
    Showjewelry,

    CopyOrder,
    setCopyOrder,

    Showcoat,
    setShowcoat,
    isSubmitting,
    ShowPant,
    setShowPant,
    initialValues
}) => {
    const [data, setdata] = useState([]);
    const [updateAddress, setUpdateAddress] = useState('')
    const location = useLocation()
    const [loading, setLoading] = useState(true);
    const [lastlog, setLastlog] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { register, handleSubmit, formState: { errors }, getValues, setValue, watch } = useForm({
        defaultValues: initialValues
    });
    const shirtSize = useSelector((state) => state.profile.shirtSize);
    const address = useSelector((state) => state.profile.address); // Access address from store


    useEffect(() => {
        if (data?.logs?.length > 0) {
            // Assuming the last log is the most recent one (last in array)
            setLastlog(data.logs[data.logs.length - 1]);
        }
    }, [data?.logs]);


    const ViewSingleorder = async () => {
        try {
            const api = `view-single-order/${refid}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response?.data);
                dispatch(fetchSingleOrderSuccess({
                    data: response.data,
                    id: response.data.id
                }));
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (refid) {
            ViewSingleorder();
        }
    }, [refid])

    useEffect(() => {
        setUpdateAddress(address)
    }, [address])

    const { single_order_style = [] } = data;

    const coat = single_order_style.find(item => item.inventory_category_type === "Coats");
    const pant = single_order_style.find(item => item.inventory_category_type === "Pants");
    const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt");
    const vest = single_order_style.find(item => item.inventory_category_type === "Vests");
    const tie = single_order_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes");

    const handleRemoveShirt = () => {
        setShowShirt(false);
        RestShirtSubmit()
    };

    const handleRemoveVest = () => {
        setShowVest(false);
        ResetVest()

    };

    const handleRemoveShoes = () => {
        setShowShoes(false);
        ResetShoe()
    };


    const handleRemoveTie = () => {
        setShowTie(false);
        RecetTie()
    };
    const handleRemovePocket = () => {
        setShowPocket(false);
        RecetPocket()
    };

    const handleRemovJewelry = () => {
        setShowjewelry(false);
        ResetJewelry()
    };
    const handleRemoveCoat = () => {
        setShowcoat(false)
        RecetCoat()

    }

    const handleRemovePant = () => {
        setShowPant(false)
        RecetPant()
    }

    function getReturnDate(eventDate) {
        if (!eventDate) return null;

        const d = moment(eventDate);
        const day = d.day(); // Sunday = 0, Monday = 1, ..., Saturday = 6

        let returnDate;

        if (day === 6 || day === 0 || day === 1 || day === 5) {
            // Saturday, Sunday, Monday → return this week's Thursday
            const daysUntilThursday = (4 - day + 7) % 7;
            returnDate = d.clone().add(daysUntilThursday, 'days');
        } else {
            // Tuesday, Wednesday, Thursday, Friday → return next week's Thursday
            const daysUntilNextThursday = ((4 - day + 7) % 7) + 7;
            returnDate = d.clone().add(daysUntilNextThursday, 'days');
        }

        return returnDate;
    }

    useEffect(() => {
        if (CopyOrder == true) {
            onSubmit();
        }
    }, [CopyOrder]);

    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 'calc(100vh - 200px)',
                                    width: '100%',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)'
                                    }}>
                                        <Loader />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }



    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">Order Review</h3>
                                    </div>
                                </div>
                            </div>

                            <div class="card card-full orderReviewNwUpdate">
                                <div class="card-inner">
                                    <div class="card-title-group mb-3">
                                        <div class="card-tools">
                                            <div class="form-control-wrap">
                                                <h5 class="mb-0"> Review Order and Submit </h5>


                                                <div className="col-md-12">
                                                    <div class="form-control-wrap dateBoxWithBtn">
                                                        <div className="ordeDateButton">
                                                            {/* <h5 class="mb-1">Order Detail</h5> */}
                                                            <p class="mb-0"><span class="fBold">Acc#: </span> {data?.account}</p>
                                                            <p class="mb-0"><span class="fBold">Ticket#: </span> {data?.ticket}</p>
                                                            <p class="mb-0"><span class="fBold">Order Type: </span> Single</p>
                                                            <p class="mb-0"><span class="fBold">Order Status: </span> <span class="badge openBadge text-capitalize font-revert"> {data?.status?.name}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-control-wrap">
                                                <p className="subOrder">
                                                    <div class="zoom-in-out-box">
                                                        <span><em class="icon ni ni-eye-fill"></em> You’re almost done! Don’t forget to click ‘Submit Order’ to finalize.</span>
                                                    </div>
                                                </p>
                                                <div class="col-md-12 mt-1 text-center">
                                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={onBack}>Back</a>
                                                    <button type="submit" onClick={(location?.pathname == "/add-order" && (showShirt && showVest && showShoes && showTie && Showjewelry && ShowPocket && Showcoat && ShowPant)) ? onRewSubmit : onSubmit} className="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}>
                                                        {isSubmitting ? (
                                                            <>
                                                                <span class="spinner"></span> Submit
                                                            </>
                                                        ) : (
                                                            "Submit"
                                                        )}
                                                    </button>                                                </div>
                                            </div>
                                            <div class="form-control-wrap">
                                                <div className="col-md-12">

                                                    <div class="form-control-wrap dateBoxWithBtn">
                                                        <div className="ordeDateButton">
                                                            <h5 class="mb-1">Rental Timeline - {data?.rental_term}</h5>
                                                            <p class="mb-0"><span class="fBold">{moment(data?.createdAt).format("MMM D, YYYY")}:</span> Order Submitted</p>
                                                            <p class="mb-0 bg-black text-white px-2 py--1 rounded"><b><span class="fBold">{moment(data?.event_date).format("MMM D, YYYY")}:</span> Event Date</b></p>
                                                            <p class="mb-0"><span class="fBold"> {
                                                                (() => {
                                                                    const eventDate = moment(data?.event_date);
                                                                    const currentDay = eventDate.isoWeekday(); // 1 = Monday, ..., 6 = Saturday, 7 = Sunday

                                                                    if (currentDay === 7) {
                                                                        // Sunday → Previous Saturday
                                                                        return eventDate.clone().subtract(1, "day").format("MMM D, YYYY");
                                                                    } else if (currentDay === 1) {
                                                                        // Monday → Previous Saturday
                                                                        return eventDate.clone().subtract(2, "days").format("MMM D, YYYY");
                                                                    } else if (currentDay === 6) {
                                                                        // Saturday → Current Saturday
                                                                        return eventDate.format("MMM D, YYYY");
                                                                    } else {
                                                                        // Tuesday to Friday → Upcoming Saturday
                                                                        return eventDate.clone().isoWeekday(6).format("MMM D, YYYY");
                                                                    }
                                                                })()
                                                            }:</span>Week Ending Date</p>
                                                            <p class="mb-0 bg-black text-white px-2 py--1 rounded"><b><span class="fBold">{
                                                                (() => {
                                                                    const eventDate = moment(data?.event_date);
                                                                    const currentDay = eventDate.isoWeekday(); // 1 = Monday, ..., 6 = Saturday, 7 = Sunday

                                                                    let weekendDate;

                                                                    if (currentDay === 7) {
                                                                        // Sunday → Previous Saturday
                                                                        weekendDate = eventDate.clone().subtract(1, "day");
                                                                    } else if (currentDay === 1) {
                                                                        // Monday → Previous Saturday
                                                                        weekendDate = eventDate.clone().subtract(2, "days");
                                                                    } else if (currentDay === 6) {
                                                                        // Saturday → Current Saturday
                                                                        weekendDate = eventDate.clone();
                                                                    } else {
                                                                        // Tuesday to Friday → Upcoming Saturday
                                                                        weekendDate = eventDate.clone().isoWeekday(6);
                                                                    }

                                                                    // Return date = Tuesday after that weekend
                                                                    return weekendDate.clone().add(3, "days").format("MMM D, YYYY");
                                                                })()
                                                            }: </span> Return Date</b></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {data?.status?.name && ['cancelRequested', 'pendingCancel', 'cancelled', 'changed', 'pendingChange'].includes(data.status.name) && (
                                        <div style={{
                                            backgroundColor: '#f7dddeff',
                                            border: '1px solid #e44a59ff',
                                            borderRadius: 6,
                                            padding: '16px',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: '#d11b2dff',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px'
                                        }}>
                                            <div style={{ fontSize: 20, lineHeight: '1', flexShrink: 0 }}>
                                                <i className="fas fa-circle-info"></i>
                                            </div>

                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                <strong style={{ fontSize: 18 }}>
                                                    {[lastlog?.change_type]
                                                        .filter(Boolean)
                                                        .join('\n')}
                                                </strong>
                                            </div>
                                        </div>
                                    )}



                                    <div className="row">
                                        <div className="col-md-4 order-md-2">
                                            <div className="eventDetailBox">
                                                <div className="firstTitle">
                                                    <p>Customer </p>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-6">
                                                        <p className="cutomerNAmeFonts"><em class="icon ni ni-user-alt"></em> {data?.first_name} {data?.last_name}</p>
                                                        <p className="mb-1"> <em className="icon ni ni-call"></em> {data?.phone ? data?.phone : "N/A"}</p>
                                                        <p><em className="icon ni ni-mail"></em> {data?.email ? data?.email : "N/A"}</p>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <hr></hr>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <p className="mb-1"><b>Submitted by:</b> {data?.measured_by ? data?.measured_by : "N/A"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="eventDetailBox">
                                                <div className="firstTitle">
                                                    <p>Contact Information</p>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    Acct: {data?.user?.account ? data.user.account : "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    Account Name: {data?.user?.companyName ? data.user.companyName : "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    {/* <em className={`icon ni ${data?.user?.firstName ? "ni-smile" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em> */}
                                                                    Owner: {data?.user?.firstName ? `${data.user.firstName} ${data.user.lastName}` : "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <em className={`icon ni ${data?.user?.email ? "ni-user-alt" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                    {data?.user?.email ? data.user.email : "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <em className={`icon ni ${data?.user?.phone ? "ni-call" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                    {data?.user?.phone ? data.user.phone : "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {data?.is_alt_pickup_enable === true ? (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Alternate Pickup Location</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p><em className="icon ni ni-user-alt"></em> {data?.affiliatedStore?.firstName || ""} {data?.affiliatedStore?.lastName || ""}</p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        Account:{" "}
                                                                        {data?.affiliatedStore?.account || ""}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        Account Name: {" "}
                                                                        {data?.affiliatedStore?.companyName || ""}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    {/* <p> {data?.shipping_address || "N/A"}</p> */}
                                                                    <p><em class="icon ni ni-map-pin"></em> {updateAddress || "N/A"}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : data?.is_drop_ship_enable === true ? (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Drop Shipping</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <p><em class="icon ni ni-user-alt"></em> {data?.name ? data?.name : ""}</p>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <p><em class="icon ni ni-call"></em>{data?.shipping_phone ? data?.shipping_phone : ""}</p>
                                                                </div>
                                                                <div className="col-md-12 mt-2">
                                                                    <p>
                                                                        <em class="icon ni ni-map-pin"></em> {data
                                                                            ? `${data.shipping_address || ""}${data.shipping_city ? "," : ""} ${data.shipping_city || ""}${data.shipping_state ? "," : ""} ${data.shipping_state || ""} ${data.shipping_zip ? "-" : ""} ${data.shipping_zip || ""}`
                                                                            : ""}
                                                                    </p>                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ) : (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Shipping Address</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p><em className="icon ni ni-user-alt"></em> {data?.user?.firstName || ""} {data?.user?.lastName || ""}</p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    {/* <p><em className="icon ni ni-call"></em> {data?.shipping_address || ""}</p> */}
                                                                    <p>
                                                                        {/* <em class="icon ni ni-map-pin"></em>  {data ? `${data.user?.addresses[0]?.billingAddress || ""}, ${data.user?.addresses[0]?.billingAddressLine2 || ""}, ${data.user?.addresses[0]?.billingCity || ""}, ${data.user?.addresses[0]?.billingState || ""}, ${data.user?.addresses[0]?.billingZip || ""}` : ""} */}
                                                                        <em class="icon ni ni-map-pin"></em>  {data ? `${data?.user?.addresses[0]?.billingAddress || ""}${data?.user?.addresses[0]?.billingAddressLine2 ? "," : ""} ${data?.user?.addresses[0]?.billingAddressLine2 || ""}${data?.user?.addresses[0]?.billingCity ? "," : ""} ${data?.user?.addresses[0]?.billingCity || ""}${data?.user?.addresses[0]?.billingState ? "," : ""} ${data?.user?.addresses[0]?.billingState || ""}${data?.user?.addresses[0]?.billingZip ? "-" : ""}${data?.user?.addresses[0]?.billingZip || ""}` : ""}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            <div className="eventDetailBox">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <div className="firstTitle">
                                                                    <p>Notes </p></div>                                                                <p>{data?.comments ? data?.comments : "N/A"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-8 order-md-1">

                                            {/** New html code start here */}
                                            {(Showcoat && coat) || (ShowPant && pant) || (showShirt && shirt) || (showVest && vest) ? (
                                                <>
                                                    {Showcoat && coat && (
                                                        <div className="eventDetailBox posRealtive">
                                                            <div className="row">
                                                                <div className="col-md-3 plNoneOrdr">
                                                                    <Image
                                                                        src={coat?.inventory_category?.inventories[0]?.image
                                                                            ? `${ImageUrl}${coat?.inventory_category?.inventories[0]?.image}`
                                                                            : "assets/images/no-photo.png"}
                                                                        className="selectCoatImgReview" alt=""
                                                                    />
                                                                </div>
                                                                <div className="col-md-9 pRNoneOrdr">
                                                                    <div className="row">
                                                                        <button type="button" className="closeCardBtn-2" onClick={handleRemoveCoat}>
                                                                            <span aria-hidden="true" className="closeBtnNew">&times;</span>
                                                                        </button>
                                                                        <div className="col-md-10">
                                                                            <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                                <li className="coatInfoSize">
                                                                                    <span>Coat:</span> {coat?.style ? coat?.style : "N/A"} {coat?.inventory_category?.inventories[0]?.description}
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                                <li className="coatInfoSize">
                                                                                    <span>Size:</span> {coat?.size ? coat.size : "N/A"}
                                                                                    {coat?.size && coat?.size_chart_category?.name
                                                                                        ? coat.size_chart_category.name === "Short"
                                                                                            ? "S"
                                                                                            : coat.size_chart_category.name === "Long"
                                                                                                ? "L"
                                                                                                : coat.size_chart_category.name === "Extra Long"
                                                                                                    ? "X"
                                                                                                    : coat.size_chart_category.name === "Regular"
                                                                                                        ? "R"
                                                                                                        : coat.size_chart_category.name === "Boys"
                                                                                                            ? "B"
                                                                                                            : ""
                                                                                        : ""}
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                                <li className="coatInfoSize">
                                                                                    <span>Insleeve:</span> {coat?.insleeve ? coat.insleeve : "N/A"}
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : null}
                                            {ShowPant && (
                                                pant &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={pant?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${pant?.inventory_category?.inventories[0]?.image}`
                                                                    : "assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <button type="button" className="closeCardBtn-2" onClick={handleRemovePant}>
                                                                    <span aria-hidden="true" className="closeBtnNew">&times;</span>
                                                                </button>
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Pant:</span> {pant?.style ? pant?.style : "N/A"} {pant?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Waist:</span> {pant?.size ? pant?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Outseam:</span> {pant?.outseam ? pant?.outseam : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Hip:</span> {pant?.hip ? pant?.hip : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                {pant?.belt && (
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Belt color:</span> {pant.belt}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {showShirt && (
                                                shirt &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={shirt?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${shirt?.inventory_category?.inventories[0]?.image}`
                                                                    : "assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <button type="button" className="closeCardBtn-2" onClick={handleRemoveShirt}>
                                                                    <span aria-hidden="true" className="closeBtnNew">&times;</span>
                                                                </button>
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Shirt:</span> {shirt?.style ? shirt?.style : "N/A"} {shirt?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Size:</span> {shirtSize ? shirtSize : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Neck:</span> {shirt?.size ? shirt?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            {/* <span>Sleeve:</span> {shirt?.sleeve ? shirt?.sleeve : "N/A"} */}
                                                                            <span>Sleeve:</span> {
                                                                                shirt?.sleeve
                                                                                    ? `${shirt.sleeve}/${Number(shirt.sleeve) + 1}`
                                                                                    : "N/A"
                                                                            }
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {showVest && (
                                                vest &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={vest?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${vest?.inventory_category?.inventories[0]?.image}`
                                                                    : "assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <button type="button" className="closeCardBtn-2" onClick={handleRemoveVest}>
                                                                    <span aria-hidden="true" className="closeBtnNew">&times;</span>
                                                                </button>
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Vest:</span> {vest?.style ? vest?.style : "N/A"} {vest?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Size:</span> {vest?.size ? vest?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {
                                                (tie || shoes || jewellery || pocketSquare) && (
                                                    <>
                                                        <h5>Additional Accessories</h5>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                {(showTie && tie) || (showShoes && shoes) || (Showjewelry && jewellery) || (ShowPocket && pocketSquare) ? (

                                                                    <div className="othderDetailBox posRealtive">
                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                {showTie && (
                                                                                    tie &&
                                                                                    <ul className="fstCategory-shirt">
                                                                                        <li className="whitTxtDetail">
                                                                                            <span>Tie:</span> {tie?.style ? tie?.style : "N/A"} {tie?.inventory_category?.inventories[0]?.description}
                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Size:</span> {data?.order_for}
                                                                                        </li>
                                                                                        <li>
                                                                                            <button type="button" onClick={handleRemoveTie} className="OtherDetailcloseCardBtn">
                                                                                                <span aria-hidden="true">&times;</span>
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                )}

                                                                                {showShoes && (
                                                                                    shoes &&
                                                                                    <ul className="fstCategory-shirt">
                                                                                        <li className="whitTxtDetail">
                                                                                            <span>Shoe:</span> {shoes?.style ? shoes?.style : "N/A"} {shoes?.inventory_category?.inventories[0]?.description}
                                                                                        </li>
                                                                                        <li>
                                                                                            <span>Size:</span> {shoes?.size ? shoes?.size : "N/A"}
                                                                                        </li>
                                                                                        <li>
                                                                                            <button type="button" onClick={handleRemoveShoes} className="OtherDetailcloseCardBtn">
                                                                                                <span aria-hidden="true">&times;</span>
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                )}

                                                                                {Showjewelry && (
                                                                                    jewellery &&
                                                                                    <ul className="fstCategory-shirt">
                                                                                        <li className="whitTxtDetail">
                                                                                            <span>Jewelry:</span> {jewellery?.style ? jewellery?.style : "N/A"} {jewellery?.inventory_category?.inventories[0]?.description}
                                                                                        </li>
                                                                                        <li>
                                                                                            <button type="button" onClick={handleRemovJewelry} className="OtherDetailcloseCardBtn">
                                                                                                <span aria-hidden="true">&times;</span>
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                )}

                                                                                {ShowPocket && (
                                                                                    pocketSquare &&
                                                                                    <ul className="fstCategory-shirt borderMarginNone">
                                                                                        <li className="whitTxtDetail">
                                                                                            <span>Pocket Square:</span> {pocketSquare?.style ? pocketSquare?.style : "N/A"} {pocketSquare?.inventory_category?.inventories[0]?.description}
                                                                                        </li>
                                                                                        <li>
                                                                                            <button type="button" onClick={handleRemovePocket} className="OtherDetailcloseCardBtn">
                                                                                                <span aria-hidden="true">&times;</span>
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }


                                            {/* End New html code here */}


                                            <hr></hr>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <h5>Audit Log</h5>
                                                    <div className="table-responsive tableScroll" id="style-14">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Date/Time</th>
                                                                    <th scope="col">User Name</th>
                                                                    <th scope="col">Change Type</th>
                                                                    <th scope="col">Previous Value</th>
                                                                    <th scope="col">New Value</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {data?.logs?.length > 0 ? (
                                                                    data.logs.map((data) => (
                                                                        <tr key={data.id || data.createdAt}>
                                                                            <th scope="row">
                                                                                {moment(data?.createdAt).format("MMM D, YYYY, h:mm A")}
                                                                            </th>
                                                                            {/* <td>{data?.user?.firstName} {data?.user?.lastName}</td> */}
                                                                            <td>
                                                                                {data?.user_name ?? `${data?.user?.firstName ?? ""} ${data?.user?.lastName ?? ""}`}
                                                                            </td>
                                                                            <td>{data?.change_type}</td>
                                                                            <td>
                                                                                {data?.previous_data
                                                                                    ? data.previous_data.includes("XL")
                                                                                        ? data.previous_data.replace("XL", "X")
                                                                                        : (() => {
                                                                                            // First check if it's a number that's too small to be a real date
                                                                                            if (!isNaN(data.previous_data) && Number(data.previous_data) < 1000) {
                                                                                                return data.previous_data;
                                                                                            }

                                                                                            const date = new Date(data.previous_data);
                                                                                            // Check if it's a valid date AND the year is reasonable
                                                                                            if (date instanceof Date && !isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < 2100) {
                                                                                                // Format as MM/DD/YYYY
                                                                                                return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
                                                                                            } else {
                                                                                                // If not a valid date, show the original value
                                                                                                return data.previous_data;
                                                                                            }
                                                                                        })()
                                                                                    : "N/A"}
                                                                            </td>

                                                                            <td>
                                                                                {data?.new_data
                                                                                    ? data.new_data.includes("XL")
                                                                                        ? data.new_data.replace("XL", "X")
                                                                                        : (() => {
                                                                                            // First check if it's a number that's too small to be a real date
                                                                                            if (!isNaN(data.new_data) && Number(data.new_data) < 1000) {
                                                                                                return data.new_data;
                                                                                            }

                                                                                            const date = new Date(data.new_data);
                                                                                            // Check if it's a valid date AND the year is reasonable
                                                                                            if (date instanceof Date && !isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < 2100) {
                                                                                                // Format as MM/DD/YYYY
                                                                                                return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
                                                                                            } else {
                                                                                                // If not a valid date, show the original value
                                                                                                return data.new_data;
                                                                                            }
                                                                                        })()
                                                                                    : "N/A"}
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="5" className="text-center"> <div className="data-not-found">
                                                                            <em className="icon ni ni-info"></em>
                                                                            <p>No data available</p>
                                                                        </div></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-control-wrap">
                                {/* <p className="subOrder">You’re almost done! Don’t forget to click ‘Submit Order’ to finalize.</p> */}
                                <div class="col-md-12 mt-1">
                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={onBack}>Back</a>
                                    <button type="submit" onClick={(location?.pathname == "/add-order" && (showShirt && showVest && showShoes && showTie && Showjewelry && ShowPocket && Showcoat && ShowPant)) ? onRewSubmit : onSubmit} className="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}>
                                        {isSubmitting ? (
                                            <>
                                                <span class="spinner"></span> Submit
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Container >
    );
}

export default OrderReview;